import { HttpClient } from '@angular/common/http';
import { Injectable, Injector, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { IAD_ConnectionSettingsDto } from '~/models/modules/Common/ad_connectionSettingsDto';
import { IAD_IntegrationSettingsDto } from '~/models/modules/Common/ad_integrationSettingsDto';
import { ApiServiceBase, API_NAMES } from '~/services/api';

@Injectable({
  providedIn: 'root'
})
export class ActiveDirectoryIntegrationSettingsService extends ApiServiceBase {

  isImportActiveDirectoryAccounts = new EventEmitter<any>();

  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
        this.setBase(API_NAMES.administration);
  }

  getIntegrationInfo():Observable<IAD_IntegrationSettingsDto>{
    return this.http.get<IAD_IntegrationSettingsDto>(this._url());
  }
  updateIntegrationInfo(model: IAD_IntegrationSettingsDto) {
    return this.http.post(this._url(), model || {});
  }
  getAllGroups(model?: IAD_ConnectionSettingsDto) {
    return this.http.post<string[]>(this._url(`/all-groups`), model || {});
  }
  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/AD_IntegrationSettings${v}`);
  }
}
